export const testAttributes = {
    SINGLE_CTA_CONTAINER: 'single-cta-container',
}

export const wpQlsinglectaClass = 'wp-block-cdm-customizations-qlsinglecta';
